import { formatDateDay, formatDateDayOfWeek, formatDateMonth } from "@utils/dateHelpers";
import { PaymentDay } from "contexts/PaymentDaysContext";
import dayjs, { Dayjs } from "dayjs";

export interface PaymentDate {
  dayOfWeek: string;
  dayOfMonth: string;
  month: string;
}

const sortDatesAsDayjs = (paymentDays: PaymentDay[]): Dayjs[] => {
  return paymentDays?.map((d) => dayjs(d.date)).sort((a, b) => (a.isBefore(b) ? -1 : 1));
};

const getPaymentDate = (date: Dayjs): PaymentDate => {
  return {
    month: formatDateMonth(date.toDate()),
    dayOfWeek: formatDateDayOfWeek(date.toDate()),
    dayOfMonth: formatDateDay(date.toDate()),
  };
};

const getClosestPaymentDay = (paymentDays: PaymentDay[]): Dayjs => {
  const lockedDays = paymentDays?.filter((item) => item?.locked);
  if (lockedDays?.length > 0) {
    const sortedLockedDays = sortDatesAsDayjs(lockedDays);
    return sortedLockedDays?.[0];
  }
  const yesterday = dayjs().subtract(1, "day");
  const sortedDates = sortDatesAsDayjs(paymentDays);

  return sortedDates?.find((date) => date.isAfter(yesterday));
};

export const getClosestPaymentDayAsObject = (paymentDays: PaymentDay[]): PaymentDate | null => {
  const closestDate = getClosestPaymentDay(paymentDays);
  if (!closestDate) {
    return null;
  }
  return getPaymentDate(closestDate);
};

export const sortDates = (paymentDays: PaymentDay[]): PaymentDate[] => {
  return sortDatesAsDayjs(paymentDays).map(getPaymentDate);
};
